import React from 'react'
import Header from '../Header'
import Journalhero from '../Journalhero/Journalhero'
import Journaltext from '../Journaltext/Journaltext'

const Journal = () => {
  return (
    <div>
        <Header />
        <Journalhero />
        <Journaltext />
    </div>
  )
}

export default Journal